import { Button, Paper, styled } from "@mui/material";

export const StyledArtFormConfiguration = {
  StyledPaper: styled(Paper)({
    display: "flex",
    flexWrap: "wrap",
    padding: 20,
    marginBottom: 20,
  }),
  StyledInput: styled("div")({
    display: "inline-flex",
    marginRight: 20,
    width: 250,
  }),
  StyledHorizontalInput: styled("div")({
    display: "inline-flex",
    padding: 10,
    width: "80%",
  }),
  ButtonContainer: styled("div")({
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "auto",
  }),
  StyledButton: styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
  })),
};